import CUSTOM_EVENT from './customEvents';
import { setMomentLocaleGlobally } from './momentLocale';
import { STORAGE_KEYS, getLocalStorage, setLocalStorage } from './storage';

export const DEFAULT_BACKUP_CULTURE = 'en-gb';

export function updateCultureSettings(currentCulture, fallbackCulture) {
  setLocalStorage(STORAGE_KEYS.currentCulture, currentCulture);
  setLocalStorage(STORAGE_KEYS.fallbackCulture, fallbackCulture);
  const cultureChangeEvent = new CustomEvent(CUSTOM_EVENT.CULTURE_CHANGE, {
    detail: { culture: currentCulture },
  });
  window.dispatchEvent(cultureChangeEvent);
  setMomentLocaleGlobally(currentCulture || fallbackCulture);
}

export function addCultureAndFallbackToParamsFromLocalStorage(additionalParams = {}) {
  const currentCulture = getLocalStorage(STORAGE_KEYS.currentCulture, DEFAULT_BACKUP_CULTURE);
  const fallbackCulture = getLocalStorage(STORAGE_KEYS.fallbackCulture, DEFAULT_BACKUP_CULTURE);
  const paramsWithCultureAndFallbackCulture = {
    culture: currentCulture,
    fallbackCulture,
    ...additionalParams,
  };
  return paramsWithCultureAndFallbackCulture;
}

export function addCultureToParamsFromLocalStorage(additionalParams = {}) {
  const currentCulture = getLocalStorage(STORAGE_KEYS.currentCulture, DEFAULT_BACKUP_CULTURE);
  const paramsWithCulture = {
    culture: currentCulture,
    ...additionalParams,
  };
  return paramsWithCulture;
}
